import { Typography, Link as MaterialLink } from '@material-ui/core';
import classNames from 'classnames';
import { Formik } from 'formik';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

import Checkbox from '@components/common/checkbox';
import useStyles from '@components/common/sign-up-form/styles';
import { UserDataForSignUp } from '@lib/api';
import { signUp } from '@store/auth/thunks';
import Validation from '@utils/validation';

import Button from '../button';
import Field from '../field';

const signUpValidation = Yup.object().shape({
  email: Validation.emailRequired,
  password: Validation.password,
  name: Validation.required,
});

interface Props {
  isLoading: boolean;
}

const SignUpForm: React.FC<Props> = (props) => {
  const { isLoading } = props;

  const classes = useStyles();
  const router = useRouter();
  const dispatch = useDispatch();

  const email = (router.query.email as string) || '';

  const onSubmit = (data: UserDataForSignUp) => {
    dispatch(signUp(data));
  };

  return (
    <div>
      <div>
        <Typography
          component="h1"
          variant="subtitle1"
          className={classes.title}
        >
          Nice to meet you!
        </Typography>
      </div>
      <Formik
        initialValues={{
          email,
          password: '',
          name: '',
          mailing: false,
        }}
        enableReinitialize
        onSubmit={onSubmit}
        validationSchema={signUpValidation}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className={classes.inputWrapper}>
              <Field
                id="name-sign-up"
                type="text"
                placeholder="Your full name"
                label="Your full name"
                variant="filled"
                name="name"
                value={values.name}
                onChange={handleChange}
                errorMessage={errors.name}
              />
            </div>
            <div className={classes.inputWrapper}>
              <Field
                id="email-sign-up"
                type="email"
                placeholder="Your email address"
                label="Your email address"
                variant="filled"
                name="email"
                value={values.email}
                onChange={handleChange}
                errorMessage={errors.email}
              />
            </div>
            <div className={classes.inputWrapper}>
              <Field
                id="password-sign-up"
                type="password"
                placeholder="Password"
                label="Password"
                variant="filled"
                name="password"
                value={values.password}
                onChange={handleChange}
                errorMessage={errors.password}
                showHidePassword
              />
            </div>
            <Checkbox
              id="send-me-tips-offers-updates"
              classWrapper={classes.mailingCheckbox}
              checked={values.mailing}
              onChange={handleChange}
              name="mailing"
              label="Send me occasional tips, offers, and updates"
              color="primary"
            />
            <Button
              id="register-button"
              type="submit"
              styleType="containedBlue"
              text="Register"
              className={classes.submitButton}
              disabled={isLoading}
              isLoading={isLoading}
            />
          </form>
        )}
      </Formik>
      <div>
        <Typography variant="body2" className={classes.textCenter}>
          By registering you agree to our{' '}
          <Link href="/policies/terms" passHref>
            <MaterialLink
              id="terms-link"
              className={classNames(classes.blueText, classes.terms)}
            >
              terms
            </MaterialLink>
          </Link>
        </Typography>
        <Typography
          variant="body2"
          className={classNames(classes.greyText, classes.textCenter)}
        >
          Already have an account?{' '}
          <Link href="/sign-in" passHref>
            <MaterialLink id="sign-in-link" className={classes.blueText}>
              Sign in
            </MaterialLink>
          </Link>
        </Typography>
      </div>
    </div>
  );
};

export default SignUpForm;
